// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"169":"65ebc9c5","480":"65ebc9c5"}[chunkId] + ".chunk.css";
};